import React, { FunctionComponent, useState } from 'react';
import classNames from 'classnames';
import uuid from 'uuid';

import { CircleImage, Container, Heading, Hidden, MenuItem, Page } from '../..';
import { BRAND } from '../../../constants/brand';

import styles from './Prices.module.scss';

import { MENU, TYPE_CRYSTAL } from '../../../constants/menu';

interface PriceListProps {
  className?: string;
  location?: object;
}

const mirroredImages = [1, 6, 7];

const PriceList: FunctionComponent<PriceListProps> = ({
  className,
  location,
}) => {
  const priceListClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-price-list`,
    className,
  );

  const [touch, setTouch] = useState(false);

  const onTouchStart = () => {
    setTouch(true);
  };

  return (
    <div onTouchStart={onTouchStart}>
      <Page className={priceListClass} location={location}>
        <section className={styles.pricing}>
          <Container>
            <Heading level={1}>Price List</Heading>
          </Container>
          <div className={styles.row}>
            <div className={styles.leftCol}>
              <Container>
                <CircleImage className={styles.circles} images={['2', '3']} />
              </Container>
            </div>
            <div className={styles.rightCol}>
              <Container>
                <table>
                  <tbody>
                    {MENU.map(item => (
                      <tr key={uuid()}>
                        <td colSpan={item.type === TYPE_CRYSTAL ? 1 : 2}>
                          {item.name}
                          {!!item.description && (
                            <div className={styles.small}>
                              {item.description}
                            </div>
                          )}
                        </td>
                        {item.prices.map((price, index) => (
                          <td key={uuid()}>
                            <div className={styles.amount}>
                              For {index + 1}
                              <Hidden
                                className={
                                  styles[`${item.type}${index === 1 ? 2 : ''}`]
                                }
                              >
                                {item.type}
                              </Hidden>
                            </div>
                            £{price}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={3}>
                        <p>Discounts for Multiple Crystals</p>
                        <p>Gold & White Gold May need to be ordered in.</p>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </Container>
            </div>
          </div>
        </section>
        <section className={styles.menu}>
          <Container>
            <Heading level={2}>Crystal Menu</Heading>
          </Container>
          <ul className={styles.menuList}>
            {MENU.map((item, i) => (
              <MenuItem
                key={uuid()}
                item={item}
                touch={touch}
                mirror={mirroredImages.includes(i)}
              />
            ))}
          </ul>
        </section>
      </Page>
    </div>
  );
};

export default PriceList;
